/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Notification methods */
export enum NotificationMethod {
  OnChain,
  Email,
  Sms,
  Push,
  InApp,
  All,
}

export type NotificationMethodArgs = NotificationMethod;

export function getNotificationMethodEncoder(): FixedSizeEncoder<NotificationMethodArgs> {
  return getEnumEncoder(NotificationMethod);
}

export function getNotificationMethodDecoder(): FixedSizeDecoder<NotificationMethod> {
  return getEnumDecoder(NotificationMethod);
}

export function getNotificationMethodCodec(): FixedSizeCodec<
  NotificationMethodArgs,
  NotificationMethod
> {
  return combineCodec(
    getNotificationMethodEncoder(),
    getNotificationMethodDecoder(),
  );
}
